<template>
  <header class="main-menu"
          v-bind:class="
          {
            '--active': activeMenu,
          }">
    <div class="container">
      <section class="main-menu__logo">
        <a href="/" class="logo">
          <img src="../assets/logo.svg">
        </a>
      </section>
      <section class="main-menu__mobile-actions">
        <button class="menu-mobile-btn"
                @click="toggleMenu()">
          Menu
          <span class="lines-wrapper">
            <span class="line line-1"></span>
            <span class="line line-2"></span>
            <span class="line line-3"></span>
          </span>
        </button>
      </section>
      <section class="main-menu__nav-list">
        <ul class="menu-list">
          <li class="menu-item"
              v-bind:key="title"
              v-for="(url, title) in menuItems">
            <a v-bind:href="url"
               v-html="title"
               :target="hrefTarget(url)"
               class="menu-link"
               @click="checkIfAnchor(url)">
            </a>
          </li>
        </ul>
      </section>
    </div>
  </header>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/menu.scss';
</style>

<script>

export default {
  name: 'menu',
  data() {
    var investorDeck = '/KeepCannabisLocal_Deck.pdf';
    var investNow = 'https://item9labs.app.dealmaker.tech/invitations/1aa03026-7402-4585-8c13-aef7985768b8/view';
    return {
      activeMenu: false,
      investorDeck,
      investNow,

      menuItems: {
        'FAQS': '#faqs',
        'Investor Deck': investorDeck,
        'Call': 'tel:+1-800-403-1140',
        'Email': 'mailto:invest@keepcannabislocal.com',
        'Invest Now': investNow,
      },
      activeMenuOut: false,
    };
  },
  components: {
  },
  methods: {
    hrefTarget (url) {
      return (url.includes(this.investorDeck) || (url.includes(this.investNow)) ? "_blank" : "_self")
    },
    checkIfAnchor(url) {
      if (url.indexOf('#') > -1) {
        this.toggleMenu();
      }
    },
    toggleMenu() {
      this.activeMenu = !this.activeMenu;
      if(!this.activeMenu) {
        document.querySelector('body').classList.remove('--noscroll');
        this.activeMenuOut = true;
        // var self = this;
        // setTimeout(() => {
        //   self.activeMenuOut = false;
        // }, 900);
      } else {
        document.querySelector('body').classList.add('--noscroll');
      }
    }
  },
};
</script>